import Select from "@/common/elements/InputElements/Select";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { getOptionsFromRefList } from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";

const ClassificationInformation = ({
  formData,
  updateFormData,
  disabled,
  startingPoint = "",
}) => {
  return (
    <section>
      <IntakeSectionHeader>
        <span>Classification</span>
      </IntakeSectionHeader>

      <FieldSecurityProvider
        entity="DetentionsArrestReports"
        startingPoint={startingPoint}
        bookingsFieldsEnabled={!disabled}
      >
        <Row gutter={16}>

          {/* Classification */}
          <Col span={8}>
            <SecureFormItem
              fieldName="classificationId"
              formItemProps={{
                name: ["detentionsArrestReports", 0, "classificationId"],
                label: "Classification",
                layout: "vertical",
              }}
            >
              <Select
                options={getOptionsFromRefList("Anoka_S3_Custody_Risk", false, false, true)}
                placeholder="Classification"
                showSearch
                variant="outlined"
              />
            </SecureFormItem>
          </Col>

          {/* As of */}
          <Col span={8}>
            <SecureFormItem
              fieldName="classificationEffectiveDate"
              formItemProps={{
                name: ["detentionsArrestReports", 0, "classificationEffectiveDate"],
                label: "As of",
                layout: "vertical",
              }}
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                showTime={false}
              />
            </SecureFormItem>
          </Col>

        </Row>
      </FieldSecurityProvider>
    </section>
  );
};

export default ClassificationInformation;